import { useAddAlert } from "@/hooks/useAddAlert";
import { useEffect, useState } from "react";
import { AdditionalSettingsResponseData, fetchAdditionalSettings, FetchAdditionalSettingsParams } from "../utils/fetchAdditionalSettings";

interface UseGetAdditionalSettingsReturn {
    loadingAdditionalSettings: boolean;
    additionalSettings: AdditionalSettingsResponseData | Record<string, never>;
    loadingAdditionalSettingsError: boolean;
}

export const useGetAdditionalSettings = ({
    directionId
}: FetchAdditionalSettingsParams = { directionId: '' }): UseGetAdditionalSettingsReturn => {
    const addAlert = useAddAlert();

    const [additionalSettings, setAdditionalSettings] = useState<AdditionalSettingsResponseData | Record<string, never>>({});

    const [loadingAdditionalSettings, setLoadingAdditionalSettings] = useState<boolean>(false);
    const [loadingAdditionalSettingsError, setLoadingAdditionalSettingsError] = useState<boolean>(false);

    const getAdditionalSettings = async (): Promise<void> => {
        setLoadingAdditionalSettings(true);
        setLoadingAdditionalSettingsError(false);
        
        try {
            const data = await fetchAdditionalSettings({ directionId });
            
            if (data?.status !== 'success') {
                throw new Error('API вернул статус не success');
            }

            setAdditionalSettings(data.data);
        } catch (error) {
            setAdditionalSettings({});
            addAlert({
                title: 'Ошибка',
                type: 'error',
                text: 'При получении доп настроек произошла ошибка'
            });
            setLoadingAdditionalSettingsError(true);
        } finally {
            setLoadingAdditionalSettings(false);
        }
    };

    useEffect(() => {
        if (!directionId) {
            setAdditionalSettings({});
            return;
        }

        getAdditionalSettings();
    }, [directionId]);

    return {
        loadingAdditionalSettings,
        additionalSettings,
        loadingAdditionalSettingsError
    };
};